// @ts-nocheck
import React, { useState } from "react";

const AddNotesModal = ({ isOpen, onClose, name, phone, onSave }) => {
  const [note, setNote] = useState("");

  if (!isOpen) return null;

  const handleSave = () => {
    if (note.trim() === "") return;
    onSave(note);
    setNote("");
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-[#182233] bg-opacity-80 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl w-full max-w-[800px] overflow-hidden">
        {/* Header */}
        <div className="bg-[#182233] px-6 py-4 flex justify-between items-center">
          <h2 className="text-xl font-semibold text-white">Add Note</h2>
          <button
            onClick={onClose}
            className="text-white hover:text-gray-300 text-lg font-semibold"
          >
            ✕
          </button>
        </div>

        {/* Content */}
        <div className="p-6">
          {/* User Info */}
          <div className="mb-6 p-4 bg-gray-50 rounded-lg">
            <p className="text-sm text-gray-700 mb-2">
              <span className="font-medium text-[#182233]">Candidate:</span> {name}
            </p>
            <p className="text-sm text-gray-700">
              <span className="font-medium text-[#182233]">Phone:</span> {phone}
            </p>
          </div>

          {/* Note Field */}
          <textarea
            value={note}
            onChange={(e) => setNote(e.target.value)}
            placeholder="Write your note here..."
            className="w-full border border-gray-300 rounded-lg p-4 focus:outline-none focus:ring-2 focus:ring-[#182233] focus:border-[#182233] transition-colors resize-none"
            rows={4}
          />

          {/* Actions */}
          <div className="mt-6 flex justify-end gap-3">
            <button
              onClick={onClose}
              className="px-5 py-2.5 rounded-lg border border-gray-300 text-[#182233] hover:bg-gray-50 transition-colors font-medium"
            >
              Cancel
            </button>
            <button
              onClick={handleSave}
              className="px-5 py-2.5 rounded-lg bg-[#182233] text-white hover:bg-opacity-90 transition-colors font-medium"
            >
              Save Note
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddNotesModal;
